import React, { useEffect, useState }from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import queryString from 'query-string';

import T from '../i18n/i18n';
import Loading from '../Loading/Loading';
import { Container, ErrorMessage, Button, LoginBox, Icon, LinkIcon, Label, DataInput, LanguageSelector, LanguageItem, ColorSelection, ColorItem, ForgotPassword, ForgotRow, Message } from './Login.styles';
import { authActions, configActions } from '../../redux/actions';
import { createUser, loginAs, sendCode, resetPassword } from '../../services/profile';

export default () => {

    const [canLogin, setCanLogin] = useState(false);
    const [canCreate, setCanCreate] = useState(false);
    const [canReset, setCanReset] = useState(false);
    const [isCreating, setIsCreating] = useState(false);
    const [isForgeting, setIsForgeting] = useState(false);
    const [isCodeSent, setIsCodeSent] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    
    const [name, setName] = useState('');
    const [color, setColor] = useState('');
    const [code, setCode] = useState('');
    const [confirm, setConfirm] = useState('');

    const token = useSelector(state => state.authState.token);
    const lang = useSelector(state => state.configState.lang);

    const dispatch = useDispatch();
    const history = useHistory();

    useEffect(() => {
        if (token) {
            history.replace('/home');
        }

        const opts = queryString.parse(history.location.search);
        const redirect = opts && opts.redirect ? opts.redirect : null;

        if (redirect) {
            localStorage.setItem('redirect', redirect);
        }
    }, [token, history]);

    useEffect(() => {
        let isValidLogin = Boolean(
            email && email.length >= 6 && 
            password && password.length >= 4
        );

        let isValidNewUser = Boolean(
            email && email.length >= 6 && 
            password && password.length >= 4 &&
            name && name.length >= 3 &&
            color && color.length === 7 &&
            confirm && confirm.length >= 4 && confirm === password
        );

        let isValidReset = Boolean(
            email && email.length >= 6 && 
            code && code.length === 6 &&
            password && password.length >= 4 &&
            confirm && confirm.length >= 4 && confirm === password
        );

        setCanLogin(isValidLogin);
        setCanCreate(isValidNewUser);
        setCanReset(isValidReset);
    }, [email, password, name, color, confirm, code]);

    const handleLogin = (e) => {
        if (!canLogin) {
            e.preventDefault();
            return false;        
        }

        (async () => {
            let token = await loginAs(email, password);

            if (token.status === 'error') {
                setErrorMessage(token.payload);
                setPassword('');
            } else {
                setErrorMessage('');
                dispatch(authActions.login(token.payload));
            }

        })();

        return true;
    }

    const handleCreate = (e) => {
        if (!canCreate) {
            e.preventDefault();
            return false;        
        }

        (async () => {
            let token = await createUser({email, password, name, color, confirm});

            if (token.status === 'error') {
                setErrorMessage(token.payload);
            } else {
                setErrorMessage('');
                dispatch(authActions.login(token.payload));
            }

        })();

        return true;
    }

    const handleKeypress = (e) => {
        if (e.which === 13 && !isCreating) {
            handleLogin();
        }
    }

    const handleSetLang = (lang) => {
        dispatch(configActions.changeLang(lang));
    }

    const handleForm = (lang) => {
        setIsCodeSent(false);
        setIsCreating(true);
        setIsForgeting(false);
        setErrorMessage('');
    }

    const handleForgot = (lang) => {
        setIsCodeSent(false);
        setIsCreating(false);
        setIsForgeting(true);
        setErrorMessage('');
    }

    const handleSendCode = async () => {
        await sendCode(email);
        setIsCodeSent(true);
        setIsCreating(false);
        setIsForgeting(false);
        setErrorMessage('');
    }

    const handleReset = () => {
        if (!canReset) {
            return false;        
        }

        (async () => {
            let req = await resetPassword(email, code, password, confirm);

            if (req.status === 'error') {
                setErrorMessage(req.payload);
            } else {
                handleCancel();
            }

        })();

        return true;
    }

    const handleCancel = () => {
        setIsCodeSent(false);
        setIsCreating(false);
        setIsForgeting(false);
        setErrorMessage('');
    }


    return <Container>
        <LoginBox>
            <LanguageSelector>
                <LanguageItem onClick={()=>{handleSetLang('pt')}} className={lang === 'pt' ? 'active' : ''} icon="pt" title="Português"/>
                <LanguageItem onClick={()=>{handleSetLang('en')}} className={lang === 'en' ? 'active' : ''} icon="en" title="English"/>
            </LanguageSelector>
            <LinkIcon href="/"><Icon /></LinkIcon>
            { errorMessage.length > 0 && <ErrorMessage>{errorMessage}</ErrorMessage> }
            
            { isForgeting && <>
                <Message><T value="login.forgotText1"/></Message>
                <Label><T value="login.email"/></Label>
                <DataInput value={email} onChange={(e) => setEmail(e.target.value)} type='text' />
                <Button onClick={handleSendCode} className='active'><T value="login.next"/></Button>
                <Button className='active' color={'#888'} onClick={handleCancel}><T value="login.cancel"/></Button>
            </>}

            { isCreating && <>
                <Label><T value="login.name"/></Label>
                <DataInput value={name} onChange={(e) => setName(e.target.value)} type='text' />
                <Label><T value="login.color"/></Label>
                <ColorSelection>
                    <ColorItem className={color === '#f44336' ? 'selected' : ''} onClick={()=>{setColor('#f44336')}} color={"#f44336"} />
                    <ColorItem className={color === '#ff80ab' ? 'selected' : ''} onClick={()=>{setColor('#ff80ab')}} color={"#ff80ab"} />
                    <ColorItem className={color === '#e1bee7' ? 'selected' : ''} onClick={()=>{setColor('#e1bee7')}} color={"#e1bee7"} />
                    <ColorItem className={color === '#7b1fa2' ? 'selected' : ''} onClick={()=>{setColor('#7b1fa2')}} color={"#7b1fa2"} />
                    <ColorItem className={color === '#3f51b5' ? 'selected' : ''} onClick={()=>{setColor('#3f51b5')}} color={"#3f51b5"} />
                    <ColorItem className={color === '#64b5f6' ? 'selected' : ''} onClick={()=>{setColor('#64b5f6')}} color={"#64b5f6"} />
                    <ColorItem className={color === '#b2ebf2' ? 'selected' : ''} onClick={()=>{setColor('#b2ebf2')}} color={"#b2ebf2"} />
                    <ColorItem className={color === '#26a69a' ? 'selected' : ''} onClick={()=>{setColor('#26a69a')}} color={"#26a69a"} />
                    <ColorItem className={color === '#66bb6a' ? 'selected' : ''} onClick={()=>{setColor('#66bb6a')}} color={"#66bb6a"} />
                </ColorSelection>
                <ColorSelection>
                    <ColorItem className={color === '#33691e' ? 'selected' : ''} onClick={()=>{setColor('#33691e')}} color={"#33691e"} />
                    <ColorItem className={color === '#d4e157' ? 'selected' : ''} onClick={()=>{setColor('#d4e157')}} color={"#d4e157"} />
                    <ColorItem className={color === '#ffee58' ? 'selected' : ''} onClick={()=>{setColor('#ffee58')}} color={"#ffee58"} />
                    <ColorItem className={color === '#ffca28' ? 'selected' : ''} onClick={()=>{setColor('#ffca28')}} color={"#ffca28"} />
                    <ColorItem className={color === '#ffa726' ? 'selected' : ''} onClick={()=>{setColor('#ffa726')}} color={"#ffa726"} />
                    <ColorItem className={color === '#8d6e63' ? 'selected' : ''} onClick={()=>{setColor('#8d6e63')}} color={"#8d6e63"} />
                    <ColorItem className={color === '#bdbdbd' ? 'selected' : ''} onClick={()=>{setColor('#bdbdbd')}} color={"#bdbdbd"} />
                    <ColorItem className={color === '#f5f5f5' ? 'selected' : ''} onClick={()=>{setColor('#f5f5f5')}} color={"#f5f5f5"} />
                    <ColorItem className={color === '#444444' ? 'selected' : ''} onClick={()=>{setColor('#444444')}} color={"#444444"} />
                </ColorSelection>
                <Label><T value="login.email"/></Label>
                <DataInput value={email} onChange={(e) => setEmail(e.target.value)} type='text' />
                <Label><T value="login.password"/></Label>
                <DataInput value={password} onChange={(e) => setPassword(e.target.value)} onKeyPress={handleKeypress} type='password' />
                <Label><T value="login.confirm" style={{marginTop:"20px"}}/></Label>
                <DataInput value={confirm} onChange={(e) => setConfirm(e.target.value)} type='password' />    
                <Button onClick={handleCreate} className={canCreate ? 'active' : ''}><T value="login.create"/></Button>
                <Button className={'active'} color={'#888'} onClick={handleCancel}><T value="login.cancel"/></Button>
            </>}

            {isCodeSent && <>
                <Message><T value="login.forgotText2"/></Message>
                <Label><T value="login.code" style={{marginTop:"20px"}}/></Label>
                <DataInput value={code} onChange={(e) => setCode(e.target.value)} type='text' name="code" autoComplete="new-password" />    
                <Label><T value="login.newPassword" /></Label>
                <DataInput value={password} onChange={(e) => setPassword(e.target.value)} type='password' autoComplete="new-password"/>    
                <Label><T value="login.confirm" /></Label>
                <DataInput value={confirm} onChange={(e) => setConfirm(e.target.value)} type='password' autoComplete="new-password" />    
                <Button onClick={handleReset} className={canReset ? 'active' : ''}><T value="login.reset"/></Button>
                <Button className={'active'} color={'#888'} onClick={handleCancel}><T value="login.cancel"/></Button>
            </>}
            
            {!isCreating && !isForgeting && !isCodeSent && <>
                <Label><T value="login.email"/></Label>
                <DataInput value={email} onChange={(e) => setEmail(e.target.value)} type='text' />
                <Label><T value="login.password"/></Label>
                <DataInput value={password} onChange={(e) => setPassword(e.target.value)} onKeyPress={handleKeypress} type='password' style={{marginBottom:0}} />
                <ForgotRow><ForgotPassword href="#" onClick={handleForgot}><T value="login.forgot"/></ForgotPassword></ForgotRow>
                <Button onClick={handleLogin} className={canLogin ? 'active' : ''}><T value="login.login"/></Button>
                <Button color={'#03a9f4'} className={'active'} onClick={handleForm}><T value="login.gotoNewProfile"/></Button>
            </>}
        </LoginBox>
        <Loading/>
    </Container>
}
;